import ApiService from "@/common/api/api.service";

const DocumentosService = {
  listar(idEmpresa, porPagina = 0, pagina = 0) {
    return ApiService.get(`ModeloDocumento?EmpresaId=${idEmpresa}&TamanhoDaPagina=${porPagina}&NumeroDaPagina=${pagina}`);
  },
  downloadArquivo(arquivoId) {
    return ApiService.downloadFile(`ModeloDocumento/download-arquivo?id=${arquivoId}`);
  },

  store: function(form) {
    return ApiService.put(`ModeloDocumento`, form);
  }
};

export default DocumentosService;
